/* eslint-disable jira/naming/disallow-filenames */
// eslint-disable-next-line jira/filename-case
import React, { Component } from 'react';
import isEqual from 'lodash/isEqual';
import noop from 'lodash/noop';
import type { Match, Route } from '@atlassian/react-resource-router';
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import {
	createSubscriber,
	type BoundActions,
	type SubscriberComponent,
} from '@atlassian/react-sweet-state';
import Store from '../../store.tsx';
import type { State } from '../../types.tsx';
import type { Actions } from '../../actions/page-events/index.tsx';
import { getApdexMatchObject } from '../../utils/index.tsx';
import CustomTrigger from './custom-trigger.tsx';

type Props = {
	isSpa: boolean;
	match: Match;
	action: string;
	route: Route;
};

// visible for testing
export const SpaStateActionsSubscriber: SubscriberComponent<
	undefined,
	BoundActions<State, Actions>,
	unknown
> = createSubscriber<State, Actions, undefined>(Store, {
	selector: null,
});

// oxlint-disable-next-line react/prefer-function-component
export class SpaStateResetPage extends Component<Props> {
	shouldComponentUpdate(nextProps: Props): boolean {
		const cleanMatch = getApdexMatchObject(this.props.match, this.props.route);
		const cleanNextMatch = getApdexMatchObject(nextProps.match, nextProps.route);
		return !isEqual(cleanMatch, cleanNextMatch);
	}

	render(): React.JSX.Element {
		const { action, match, route, isSpa } = this.props;

		const shouldNotUpdate = action === 'REPLACE' && (!isSpa || route.name === 'issue-navigator');

		return (
			<SpaStateActionsSubscriber>
				{(_, { resetCurrentPage }) => (
					<CustomTrigger
						resetCurrentPage={shouldNotUpdate ? noop : resetCurrentPage}
						match={getApdexMatchObject(match, route)}
						route={route}
					/>
				)}
			</SpaStateActionsSubscriber>
		);
	}
}
